import { useQuery } from "@tanstack/vue-query";

import { getApiAccount } from "@/api/account/api";
import { useToast } from "@/composables/useToast";

export const useAccount = () => {
	const { addToast } = useToast();

	return useQuery({
		queryKey: ["account"],
		queryFn: async () => {
			try {
				const response = await getApiAccount();

				if (response.status === 200) {
					return response.data;
				}

				throw response;
			} catch (e: any) {
				addToast({
					title: "Failed to fetch account",
					message: "message" in e ? e.message : undefined,
					color: "red",
					icon: { name: "error", type: "filled" },
				});

				throw e;
			}
		},
	});
};
